import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { DashboardTransactionsTable } from './transactions/DashboardTransactionsTable';
import { StationsAndConnectorsCardChart } from './charts/StationsAndConnectorsCardChart';

export const TMHDashboard = () => {
  const theme = useTheme();
  const isSmallerThanLXLScreen = useMediaQuery(theme.breakpoints.down('xl'));

  return (
    <>
      <Box
        sx={{
          paddingBottom: 6,
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
        }}
      >
        <Grid item container xs={12}>
          <StationsAndConnectorsCardChart stacked />
        </Grid>
      </Box>

      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          flex: 1,
          minHeight: isSmallerThanLXLScreen ? '600px' : 'unset',
        }}
      >
        <DashboardTransactionsTable />
      </Grid>
    </>
  );
};
